import { GetBackNotifichePriorita } from '@framework/api-client/api/backoffice/schemas/getBackNotifichePriorita.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import {
  type SearchableField,
  SearchableFieldGroup,
  SearchableFieldType,
} from '@framework/ui/components/search/ISearchableField.tsx';
import { capitalize } from 'lodash';

/**
 * Restituisce i campi di ricerca comuni delle notifiche,
 * condivisi tra backoffice e frontoffice.
 */
export function getCommonNotificationSearchFields(): SearchableField[] {
  return [
    {
      type: SearchableFieldType.Text,
      name: 'oggetto',
      label: t('notifiche-campo-oggetto', 'Oggetto'),
      group: SearchableFieldGroup.Filters,
    },
    {
      type: SearchableFieldType.Select,
      name: 'priorita',
      label: t('notifiche-campo-priorita', 'Priorità'),
      group: SearchableFieldGroup.Filters,
      options: Object.values(GetBackNotifichePriorita).map(value => ({
        label: capitalize(value),
        value,
      })),
    },
    {
      type: SearchableFieldType.Radio,
      name: 'flVista',
      label: t('notifiche-campo-letta', 'Letta'),
      group: SearchableFieldGroup.Filters,
      options: [
        { label: t('notifiche-campo-letta', 'Letta'), value: 'true' },
        { label: t('notifiche-campo-non-letta', 'Non Letta'), value: 'false' },
      ],
    },
  ];
}

/**
 * Crea un campo DateRange per la ricerca notifiche.
 * Centralizza la struttura comune evitando duplicazione tra BO e FO.
 */
export function notificationDateRangeField(options: {
  name: string;
  label: string;
  fromName: string;
  fromLabel: string;
  toName: string;
  toLabel: string;
}): SearchableField {
  return {
    type: SearchableFieldType.DateRange,
    name: options.name,
    label: options.label,
    from: {
      name: options.fromName,
      label: options.fromLabel,
    },
    to: {
      name: options.toName,
      label: options.toLabel,
    },
    group: SearchableFieldGroup.Filters,
  };
}
